import { observable } from '@legendapp/state';

// Online/Offline status tracking
export const sync$ = observable({
  isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
  isSyncing: false,
  pendingChanges: 0,
});

// Listen to online/offline events
if (typeof window !== 'undefined') {
  window.addEventListener('online', () => {
    sync$.isOnline.set(true);
    console.log('[Sync] Online');
  });

  window.addEventListener('offline', () => {
    sync$.isOnline.set(false);
    console.log('[Sync] Offline');
  });
}

// Helper functions
export const setSyncing = (isSyncing) => {
  sync$.isSyncing.set(isSyncing);
};

export const incrementPending = () => {
  sync$.pendingChanges.set(sync$.pendingChanges.get() + 1);
};

export const decrementPending = () => {
  const current = sync$.pendingChanges.get();
  if (current > 0) {
    sync$.pendingChanges.set(current - 1);
  }
};

export const clearPending = () => {
  sync$.pendingChanges.set(0);
};

